import { Chip } from '@mui/material'
import type { ChipProps } from '@mui/material'
import { dayStatusColor, dayStatusLabel } from '../theme'

export function StatusChip({ status, size = 'small' }: { status: string; size?: ChipProps['size'] }) {
  return (
    <Chip
      size={size}
      label={dayStatusLabel[status] ?? status}
      color={dayStatusColor[status] ?? 'default'}
      variant="outlined"
    />
  )
}
